import { Locale } from 'modules/i18n';

export const trafficMapTranslation = {
  [Locale.en]: {
    title: 'Top 10 countries by traffic',
  },
};
